<template>
	<div class="container padding-top">
		<div class="about-title">路上读书，为有趣而声。</div>
		<div class="about-content">路上读书，成立于2014年10月，是国内最早从事音频书节目的内容制作商，行业从事至今已超过10年。从2016年开始为国内TOP10音视频平台稳定提供优质音频书节目，是有书共读、考拉FM（听伴）、喜马拉雅、十点读书、微信读书、爱奇艺、蜻蜓FM、小鹅通、华为电台、小米、百度读书、知乎及智能音箱天猫精灵、小度、科大讯飞等平台的首批付费节目内容供应商与战略合作伙伴，也是全网首个优质音频节目覆盖面积最广、累计播放量最早超10亿的精品音频节目博主，节目广受平台与用户喜爱和推荐。
		</div>

		<div class="book-link">
			<li v-for="(item, index) in linkList" :key="index">
				<a v-bind:href="item.url" target="_blank" class="card">
					<div><img v-bind:src="item.img" /></div>
					<div>{{item.name}}</div>
				</a>
			</li>
		</div>

	</div>
</template>

<script>
	export default {
		metaInfo() {
			return {
				title: "路上畅听首页" + this.$store.state.title,
				meta: [{
						name: "keywords",
						content: this.$store.state.keywords,
					},
					{
						vmid: "description",
						name: "description",
						content: this.$store.state.description,
					},
				],
			};
		},
		data() {
			return {
				linkList: [{
					name: '喜马拉雅--路上读书频道',
					url: 'https://xima.tv/1_CyQ981?_sonic=0',
					img: '/linkImg/ximalaya.jpg'
				},
				{
					name: '微信读书--路上读书频道',
					url: 'https://at.qq.com/album-share/index?albumId=3110000052&senderVid=17946410&source=weread-share',
					img: '/linkImg/weixindushu.jpg'
				},
				{
					name: '网易云音乐--路上读书频道',
					url: 'https://music.163.com/#/user/home?id=346257841',
					img: '/linkImg/wangyiyunyinyue.jpg'
				},
				{
					name: '爱奇艺--路上读书频道',
					url: 'https://zhishi.m.iqiyi.com/shop/P1c07dd2b9c3b434695f90535898f217d/home',
					img: '/linkImg/aiqiyi.jpg'
				},
				{
					name: '当当云阅读--路上读书频道',
					url: 'http://e.dangdang.com/media/h5/ddreader50//tshsjd.html?way=listenbook',
					img: '/linkImg/dangdangyunyuedu.jpg'
				},
				{
					name: '京东读书--路上读书频道',
					url: 'https://e.m.jd.com/search?search=路上读书',
					img: '/linkImg/jingdongdushu.jpg'
				},
				{
					name: '今日头条--路上读书频道',
					url: 'https://www.toutiao.com/c/user/token/MS4wLjABAAAAliNPo-7_eS3Kbi0HrVxW9dOGQMBsHDSOj6U8HEO_e7k/',
					img: '/linkImg/jinritoutiao.jpg'
				},
				{
					name: '抖音--路上读书频道',
					url: 'https://v.douyin.com/iDWYkwsk/',
					img: '/linkImg/douyin.jpg'
				},
				{
					name: '小红书--路上读书频道',
					url: 'https://www.xiaohongshu.com/user/profile/5ecb72790000000001002b1c',
					img: '/linkImg/xiaohongshu.jpg'
				},
				{
					name: '百家号--路上读书频道',
					url: 'https://author.baidu.com/home/1623962089629280',
					img: '/linkImg/baijiahao.jpg'
				},
				{
					name: '新浪微博--路上读书频道',
					url: 'https://m.weibo.cn/u/7814203595?t=&luicode=10000011&lfid=100103type%3D1%26q%3D路上读书',
					img: '/linkImg/xinlangweibo.jpg'
				},
				{
					name: '知乎--路上读书频道',
					url: 'https://www.zhihu.com/org/lu-shang-du-shu',
					img: '/linkImg/zhihu.jpg'
				},
				{
					name: '蜻蜓FM--路上读书频道',
					url: 'https://www.qtfm.cn/podcasters/ac809793f71145852dffd2ec3d025f22/',
					img: '/linkImg/qingtingfm.jpg'
				},
				{
					name: '腾讯视频--路上读书频道',
					url: 'https://v.qq.com/biu/creator/home?vcuid=9000099304',
					img: '/linkImg/tengxunshipin.jpg'
				},
				{
					name: '微信公众号--路上读书',
					url: 'https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzA5NTkwNTc5OA==&action=getalbum&album_id=2862925980049440769&scene=173&subscene=&sessionid=svr_51b56afe580&enterid=1734136411&from_msgid=2247505467&from_itemidx=1&count=3&nolastread=1#wechat_redirect',
					img: '/linkImg/gongzhonghao.jpg'
				},],
			};
		},
		methods: {

		},
	};
</script>

<style scoped>
	.title {
		font-family: PingFangSCHeavy;
		font-size: 14px;
		font-weight: 600;
	}

	.pointer {
		cursor: pointer;
	}

	.pointer:hover {
		color: #42b983;
	}

	a {
		text-decoration: none;
	}

	.padding-top {
		padding-top: 50px;
	}

	.about-title {
		height: 60px;
		line-height: 60px;
		text-align: center;
		border-radius: 2px;
		font-size: 20px;
		font-family: Source Han Serif CN;
		font-weight: bold;
	}

	.about-content {
		line-height: 200%;
		text-indent: 2rem;
	}

	.book-link {
		margin: 10px 0;
		width: 100%;
		list-style: none; 
		overflow: hidden;
	}

	.book-link li {
		width: 33.33%;
		float: left;
	}
	.book-link li .card{
		border: 1px solid #f0f0f0;
		display: block;
		background-color: #f8f8f8;
		padding: 10px;
		margin: 10px 10px 10px 0;
	}

	.book-link li img {
		width: 100%;
	}

	.book-link li a {
		color: #222222;
	}

	.book-link li a:hover {
		color: #42b983;
	}

	.book-link li p {
		font-weight: 600;
	}
</style>
